import { render, staticRenderFns } from "./account-setting.vue?vue&type=template&id=3bc6e30f&"
import script from "./account-setting.vue?vue&type=script&lang=ts&"
export * from "./account-setting.vue?vue&type=script&lang=ts&"
import style0 from "./account-setting.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./account-setting.vue?vue&type=style&index=1&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports